
import React from 'react';
import { Shell } from "@/components/ui/shell";
import { ScrollArea } from "@/components/ui/scroll-area";
import AuthNavigation from '@/components/navigation/AuthNavigation';

const Privacy = () => {
  return (
    <Shell className="max-w-5xl pt-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Privacy Policy</h1>
        <AuthNavigation />
      </div>
      
      <div className="space-y-6">
        <div>
          <p className="text-gray-500 dark:text-gray-400 mt-2">Last updated: April 25, 2025</p>
        </div>
        
        <ScrollArea className="h-[600px] rounded-md border p-6">
          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Data Collection</h2>
              <p className="text-gray-600">We collect minimal personal information necessary to provide our services. Your payment credentials are stored securely on your device and are never transmitted to our servers.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Data Usage</h2>
              <p className="text-gray-600">We use your data solely for processing payments, verifying your identity, and improving our services. We employ AI technology to enhance security and prevent fraud.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Data Storage</h2>
              <p className="text-gray-600">Your payment information is stored locally on your device using advanced encryption. Transaction records are stored securely in compliance with financial regulations.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Data Sharing</h2>
              <p className="text-gray-600">We never sell your personal information. Data is only shared with our payment processor (Stripe) to facilitate transactions.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Your Rights</h2>
              <p className="text-gray-600">You have the right to access, correct, or delete your personal information. Contact us at privacy@bluetoothcash.net for any privacy-related inquiries.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Cookies</h2>
              <p className="text-gray-600">We use essential cookies to maintain your session and preferences. No tracking or marketing cookies are used.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Updates</h2>
              <p className="text-gray-600">We may update this privacy policy occasionally. Users will be notified of any significant changes.</p>
            </section>
          </div>
        </ScrollArea>
      </div>
    </Shell>
  );
};

export default Privacy;
